import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  tr: {
    // Header
    brand: 'Threat.live',
    tagline: 'Threat Intelligence Platform',
    
    // Stats
    totalActiveDevices: 'Toplam Aktif Node',
    totalDetectedIPs: 'Tespit Edilen IP Adresi',
    currentlyListedIPs: 'Aktif Listelenen IP',
    
    // Sections
    dailyStatistics: 'Günlük İstatistikler',
    asnStatistics: 'ASN İstatistikleri',
    countryStatistics: 'Ülke İstatistikleri',
    
    // Chart
    newIPs: 'Yeni IP Sayısı',
    date: 'Tarih',
    
    // Table headers
    asn: 'ASN',
    organization: 'Organizasyon',
    ipCount: 'IP Sayısı',
    country: 'Ülke',
    
    // About section
    whatIsRTBH: 'Threat.live Nedir?',
    aboutDescription: 'Siber tehditlere karşı güvenliği güçlendirmek için tasarlanmış erken uyarı ve koruma sistemi',
    aboutText1: 'Threat.live, dünya genelindeki veri merkezlerinde konumlandırılmış cihazlar aracılığıyla internet üzerindeki zararlı aktiviteleri tespit eden ve bu tehditleri gerçek zamanlı olarak engelleyen kolektif bir savunma ağıdır.',
    aboutText2: 'Sistemimiz, çeşitli veri merkezlerinde bulunan cihazlar aracılığıyla internet trafiğini analiz eder ve kötü amaçlı IP adreslerini otomatik olarak tespit ederek anında önlem alır. Bu, botnet saldırıları, DDoS saldırıları, brute force denemeleri ve diğer siber tehditlere karşı proaktif savunma sağlar.',
    
    // Features
    protection: 'Koruma',
    protectionDesc: 'Siber saldırıları ve güvenlik ihlallerini gerçek zamanlı engelleme',
    monitoring: 'İzleme',
    monitoringDesc: 'Kötü amaçlı aktivitelerin sürekli taranması ve analizi',
    sharing: 'Paylaşım',
    sharingDesc: 'Ağ içinde tehdit istihbaratının güvenli paylaşımı',
    
    // Footer
    allRightsReserved: 'Tüm hakları saklıdır.',
    ipList: 'IP Listesi',
    setupGuide: 'Kurulum Kılavuzu',
    tools: 'Araçlar',
    portal: 'Portal',
    contact: 'İletişim',
    
    // Loading
    loading: 'Yükleniyor...',
    error: 'Veri yüklenirken hata oluştu',
    retry: 'Tekrar Dene',
    
    // Misc
    lastUpdated: 'Son Güncelleme',
    viewAll: 'Tümünü Gör',
    nodes: 'Node',
    
    // Dashboard Page
    dashboard: 'Dashboard',
    bgpSessions: 'BGP Oturumları',
    bgpSessionsDesc: 'Aktif BGP oturumlarınızı yönetin',
    newBgpSession: 'Yeni BGP Oturumu',
    createBgpSession: 'BGP Oturumu Oluştur',
    sessionName: 'Oturum Adı',
    neighborIp: 'Komşu IP Adresi',
    localAs: 'Yerel AS Numarası',
    remoteAs: 'Uzak AS Numarası',
    status: 'Durum',
    established: 'Aktif',
    idle: 'Beklemede',
    connect: 'Bağlanıyor',
    active: 'Aktif',
    actions: 'İşlemler',
    edit: 'Düzenle',
    delete: 'Sil',
    cancel: 'İptal',
    create: 'Oluştur',
    noSessions: 'Henüz BGP oturumu bulunmuyor',
    
    // DNS Test
    recursiveDnsTest: 'Recursive DNS Testi',
    recursiveDnsDesc: 'Bir IP adresinin recursive DNS sunucusu olup olmadığını test edin',
    enterIpAddress: 'IP Adresi Girin',
    testDns: 'Test Et',
    testing: 'Test Ediliyor...',
    dnsResult: 'Test Sonucu',
    isRecursive: 'Recursive DNS Sunucusu',
    notRecursive: 'Recursive DNS Değil',
    dnsError: 'Test sırasında hata oluştu',
    
    // Vulnerability Test
    vulnerabilityTest: 'Güvenlik Açığı Taraması',
    vulnerabilityDesc: 'IP veya domain üzerinde güvenlik açığı taraması yapın',
    comingSoon: 'Çok Yakında',
    comingSoonDesc: 'Bu özellik üzerinde çalışıyoruz',
    
    // BGP Modal
    bgpModalTitle: 'Yeni BGP Oturumu Oluştur',
    bgpModalDesc: 'BGP komşusu için gerekli bilgileri girin',
    description: 'Açıklama',
    optional: 'opsiyonel',
    prefixLimit: 'Prefix Limiti',
    password: 'Şifre',
    multihop: 'Multihop',
    enabled: 'Etkin',
    disabled: 'Devre Dışı',
  },
  en: {
    // Header
    brand: 'Threat.live',
    tagline: 'Threat Intelligence Platform',
    
    // Stats
    totalActiveDevices: 'Total Active Nodes',
    totalDetectedIPs: 'Total Detected IPs',
    currentlyListedIPs: 'Currently Listed IPs',
    
    // Sections
    dailyStatistics: 'Daily Statistics',
    asnStatistics: 'ASN Statistics',
    countryStatistics: 'Country Statistics',
    
    // Chart
    newIPs: 'New IPs',
    date: 'Date',
    
    // Table headers
    asn: 'ASN',
    organization: 'Organization',
    ipCount: 'IP Count',
    country: 'Country',
    
    // About section
    whatIsRTBH: 'What is Threat.live?',
    aboutDescription: 'An early warning and protection system designed to strengthen cybersecurity against threats',
    aboutText1: 'Threat.live is a collective defense network that detects harmful activities on the internet through devices positioned in data centers around the world and blocks these threats in real-time.',
    aboutText2: 'Our system analyzes internet traffic through devices located in various data centers and automatically identifies malicious IP addresses, taking immediate action. This provides proactive defense against botnet attacks, DDoS attacks, brute force attempts, and other cyber threats.',
    
    // Features
    protection: 'Protection',
    protectionDesc: 'Real-time blocking of cyber attacks and security breaches',
    monitoring: 'Monitoring',
    monitoringDesc: 'Continuous scanning and analysis of malicious activities',
    sharing: 'Sharing',
    sharingDesc: 'Secure sharing of threat intelligence within the network',
    
    // Footer
    allRightsReserved: 'All rights reserved.',
    ipList: 'IP Address List',
    setupGuide: 'Setup Guide',
    tools: 'Tools',
    portal: 'Portal',
    contact: 'Contact',
    
    // Loading
    loading: 'Loading...',
    error: 'Error loading data',
    retry: 'Retry',
    
    // Misc
    lastUpdated: 'Last Updated',
    viewAll: 'View All',
    nodes: 'Nodes',
    
    // Dashboard Page
    dashboard: 'Dashboard',
    bgpSessions: 'BGP Sessions',
    bgpSessionsDesc: 'Manage your active BGP sessions',
    newBgpSession: 'New BGP Session',
    createBgpSession: 'Create BGP Session',
    sessionName: 'Session Name',
    neighborIp: 'Neighbor IP Address',
    localAs: 'Local AS Number',
    remoteAs: 'Remote AS Number',
    status: 'Status',
    established: 'Established',
    idle: 'Idle',
    connect: 'Connect',
    active: 'Active',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    create: 'Create',
    noSessions: 'No BGP sessions found',
    
    // DNS Test
    recursiveDnsTest: 'Recursive DNS Test',
    recursiveDnsDesc: 'Test if an IP address is a recursive DNS server',
    enterIpAddress: 'Enter IP Address',
    testDns: 'Test',
    testing: 'Testing...',
    dnsResult: 'Test Result',
    isRecursive: 'Recursive DNS Server',
    notRecursive: 'Not a Recursive DNS',
    dnsError: 'Error during test',
    
    // Vulnerability Test
    vulnerabilityTest: 'Vulnerability Scan',
    vulnerabilityDesc: 'Scan IP or domain for security vulnerabilities',
    comingSoon: 'Coming Soon',
    comingSoonDesc: 'We are working on this feature',
    
    // BGP Modal
    bgpModalTitle: 'Create New BGP Session',
    bgpModalDesc: 'Enter the required information for the BGP neighbor',
    description: 'Description',
    optional: 'optional',
    prefixLimit: 'Prefix Limit',
    password: 'Password',
    multihop: 'Multihop',
    enabled: 'Enabled',
    disabled: 'Disabled',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('threat-live-lang') || 'en';
    }
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('threat-live-lang', language);
    // Keep <html lang=""> in sync so CSS text-transform: uppercase uses the
    // correct locale casing rules (e.g. avoid Turkish i → İ on English text).
    if (typeof document !== 'undefined') {
      document.documentElement.lang = language === 'tr' ? 'tr' : 'en';
    }
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
